export const formatToToman = (value: number) => {
  if (!value && value !== 0) return "";
  const toman = Math.floor(value / 10);
  return toman.toLocaleString("fa-IR") + " ریال";
};
